<template>
    <div class="main-content row mx-0">
        <div 
            class="col-12 col-sm-8 col-md-9"
            :class="{'pr-0' : $breakpoint.lgAndDown && !$breakpoint.xsOnly }"
        >
            <div class="row mb-4">
                <div class="col-md-12">
                    <live-terminal-view/>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-12">
                    <live-prices/>
                </div>
            </div>
            <order-history class="mb-4" />
            <div class="row mb-4">
                <div class="col-md-12">
                    <h2 class="first-header heading-medium">
                        <i class="fas fa-calendar-check mr-2" ></i>Selling Report
                    </h2>
                    <volumes-per-product class="card" />
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-4 col-md-3">
            <div class="d-flex justify-content-end">
            <refresh-information/>
            </div>
            <h2 class="first-header">Tools</h2>
            <div class="tools">
                <market-change class="mb-4" />
                <dashboard-graphs class="mb-4" />
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import PageRefreshMixin from '@/mixins/PageRefreshMixin';
import LiveTerminalView from './LiveTerminalTables/LiveTerminalView.vue';
import LivePrices from '@/pages/Views/Seller/LivePrices/LivePrices.vue';
import OrderHistory from '@/pages/Purchase/PurchaseHistory.vue';
import DashboardGraphs from '@/components/Graphs/DashboardGraphs.vue';
import MarketChange from '@/components/Tools/MarketChange.vue';
import VolumesPerProduct from '@/components/Graphs/VolumesPerProduct.vue';
import RefreshInformation from '@/components/RefreshInformation.vue';
import { mapActions, mapGetters } from 'vuex';

const { detect } = require('detect-browser');

export default {
    mixins: [breakpoint, PageRefreshMixin],
    components:{
        DashboardGraphs,
        MarketChange,
        LiveTerminalView,
        LivePrices,
        OrderHistory,
        VolumesPerProduct,
        RefreshInformation
    },
    computed: {
        ...mapGetters('login', ['isPricingEngineEnabled']),
    },
    async created() {
        this.getOffersTimeAvailability();
        this.getAllOffersForUser();

        if (this.isPricingEngineEnabled) {
            this.$store.dispatch("metadata/getStaMatrix");
        }

        this.startPageRefresh(this.refreshPageData);
    },
    data(){
        return {
            browser: detect()
        }
    },
    methods: {
        ...mapActions('sellerOffers', ['getOffersTimeAvailability', 'getAllOffersForUser']),
        refreshPageData() {
            this.getAllOffersForUser();
        },
    },
}
</script>
